/**
 * @file     licenseeLine.ts
 * @purpose  The one platform and licensee line printed in the footer, emails, PDFs and page copy.
 */
import { brandConfig } from './brandConfig';

export const LICENSEE_LINE = `${brandConfig.companyDisplayName} is a platform by ${brandConfig.agentName}, REALTOR®, ${brandConfig.brokerageName}`;
